import { Box, makeStyles, useMediaQuery } from "@material-ui/core";
import clsx from "clsx";
import { useEffect, useMemo } from "react";
import TravaStepper from "src/components/TravaStepper";
import AuthorizationWrapper from "src/components/Wrapper/AuthorizationWrapper";
import AddAssetProvider, { useAddAssetContext } from "src/context/monitoring/addAssetContext";
import { usePoolMonitoringContext } from "src/context/monitoring/poolMonitoringContext";
import useLowerAddressParam from "src/hooks/useLowerAddressParam";
import FirstStep from "./FirstStep";
import SecondStep from "./SecondStep";
import ThirdStep from "./ThirdStep";

const useStyle = makeStyles(() => ({
  stepForm: {
    marginTop: 0,
  },
  inactiveStepForm: {
    display: "none",
  },
}));

function AddAssetLayout({ ...props }) {
  const cls = useStyle();
  const { pool } = useLowerAddressParam();
  const { stepStatus, setter } = useAddAssetContext();
  const { data } = usePoolMonitoringContext();
  const isMobile = useMediaQuery("(max-width:600px)");

  const providerId = useMemo(() => {
    if (data && pool) return data[pool].overview.providerId;
    return undefined;
  }, [pool, data]);

  function beforeunload(e) {
    e.preventDefault();
    e.returnValue = true;
  }

  useEffect(() => {
    window.addEventListener("beforeunload", beforeunload);
    return function cleanup() {
      window.removeEventListener("beforeunload", beforeunload);
    };
  }, []);

  return (
    <Box {...props} display="flex" flexDirection={isMobile ? "column" : "row"} width="100%" mt={2}>
      <TravaStepper
        activeStep={stepStatus.activeStep}
        activeStatus={stepStatus.activeStatus}
        stepCount={3}
        event={{
          stepClick: (index) => {
            setter.setStepStatus((draft) => {
              draft["selectedStep"] = index;
            });
          },
        }}
        des={[
          "Config asset parameters",
          "Init interest rate strategy with users parameters",
          "Init reserves in lending pool instance",
        ]}
      />

      <Box flexGrow={1}>
        <FirstStep
          des="Config asset parameters"
          className={clsx(cls.stepForm, { [cls.inactiveStepForm]: stepStatus.selectedStep != 0 })}
        />
        <SecondStep
          targetProviderId={providerId}
          des="Init interest rate strategy with users parameters"
          className={clsx(cls.stepForm, { [cls.inactiveStepForm]: stepStatus.selectedStep != 1 })}
        />
        <ThirdStep
          targetProviderId={providerId}
          des="Init reserves in lending pool instance"
          className={clsx(cls.stepForm, { [cls.inactiveStepForm]: stepStatus.selectedStep != 2 })}
        />
      </Box>
    </Box>
  );
}

export default function AddAsset({ ...props }) {
  return (
    <AddAssetProvider>
      <AuthorizationWrapper>
        <AddAssetLayout {...props} />
      </AuthorizationWrapper>
    </AddAssetProvider>
  );
}
